import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { t, font, Button } from "@realtyflows/ui";

export default function ConfirmModal({ title, message, onConfirm, onCancel, confirmLabel = "Delete", confirmVariant = "danger" }) {
  const [left, setLeft] = useState(0);

  useEffect(() => {
    const sidebar = document.querySelector(".rf-sidebar");
    if (sidebar) {
      setLeft(sidebar.offsetWidth);
    } else {
      // Two-rail sidebar uses position:fixed — detect via main content margin
      const main = document.querySelector("[data-main-content]");
      if (main) setLeft(main.getBoundingClientRect().left);
    }
  }, []);

  return createPortal(
    <div onClick={onCancel} style={{
      position: "fixed", top: 0, right: 0, bottom: 0, left,
      background: "rgba(0,0,0,0.45)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 200, animation: "fadeUp 0.2s ease", fontFamily: font.body,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: t.surface, borderRadius: 14, width: 360,
        border: `1.5px solid ${t.border}`, boxShadow: "0 16px 48px rgba(0,0,0,0.3)",
        animation: "scaleIn 0.15s ease",
      }}>
        <div style={{ padding: "18px 22px 14px", borderBottom: `1px solid ${t.border}` }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: t.textPrimary, fontFamily: font.display }}>
            {title || "Confirm Delete"}
          </div>
        </div>
        <div style={{ padding: "16px 22px" }}>
          <div style={{ fontSize: 13, lineHeight: 1.5, color: t.textPrimary, fontFamily: font.body }}>
            {message || "Are you sure? This action cannot be undone."}
          </div>
        </div>
        <div style={{ padding: "14px 22px 18px", display: "flex", gap: 10, justifyContent: "flex-end", borderTop: `1px solid ${t.border}` }}>
          <Button variant="ghost" size="sm" onClick={onCancel}>Cancel</Button>
          <Button variant={confirmVariant} size="sm" onClick={onConfirm}>{confirmLabel}</Button>
        </div>
      </div>
    </div>,
    document.body
  );
}
